import { useContext, useEffect, useState } from "react";
import Footer from "../../components/Footer/Footer";
import "./style.css";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import InputMask from "react-input-mask";
import { CompraContext } from "../../context/CompraContext";
import Erro from "../../components/Alert/Erro";
import {
  validateCPF,
  validateCNPJ,
  validateCep,
  validateUF,
  validateEmail,
  validatePhone,
} from "validations-br";
import useAutoCep from "../../hooks/useAutoCep";
import { NegocioComContato, PatchNegocio, PostEmpresa } from "../../services/crmService";
import { crmEstagioExpress } from "../../data/crmEstagioExpress";
import { ObterProdutoExpress } from "../../data/crmProdutoExpress";
import { convertToISO } from "../../util/formatacao";
import cartao from "../../images/Compra/cartao.svg";
import token from "../../images/Certificado/token.svg";
import file from "../../images/Certificado/file.webp";
import certificadoescudo from "../../images/Certificado/certificadoescudo.webp";
import cartaoleitora from "../../images/Certificado/cartaoleitora.svg";
import CardCertificadoSelecionado from "../../components/Card/CardCertificadoSelecionado";


function Cadastro() {
  const {
    Cadastro,
    setCadastro,
    msgErro,
    setMsgErro,
    setAbreModal,
    GeraVenda,
    ProdutoCompra,
    Revenda,
  } = useContext(CompraContext);
  const { fetchEndereco, disabledFields, isCepInvalido } = useAutoCep();
  const [step, setStep] = useState(1);
  const [check, setCheck] = useState(false);
  const [dados, setDados] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();
  const [gclid, setGclid] = useState("");

  const [temCNH, setTemCNH] = useState(null);
  const [emitiuCertificado, setEmitiuCertificado] = useState(null);

  const podeAvancar =
    temCNH === "sim" || (temCNH === "nao" && emitiuCertificado === "sim");

  const handleNext = () => {
    if (step < 3) setStep(step + 1);
  };
  const handlePrev = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleChange = (event) => {
    if (event.target.name === "uf") {
      event.target.value = event.target.value.toUpperCase();
    }
    setCadastro({ ...Cadastro, [event.target.name]: event.target.value });
  };

  const handleCheckbox = (event) => {
    setCheck(event.target.checked);
  };

  const handleDados = (event) => {
    setDados(event.target.value);
  };

  const verifica = (e) => {
    e.preventDefault();
    if (!certificadoCnpj) {
      // Para CPF, preenche os campos de representante com os dados do step 2
      setCadastro({
        ...Cadastro,
        representanteCpf: Cadastro.documento,
        representanteNome: Cadastro.nome,
        representanteTelefone: Cadastro.telefone,
      });
    }
    if (typeof Cadastro.email === "undefined" || Cadastro.email === "") {
      setMsgErro("Campo email obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    } else if (!validateEmail(Cadastro.email)) {
      setMsgErro("E-mail inválido");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    }

    if (
      typeof Cadastro.dataNascimento === "undefined" ||
      Cadastro.dataNascimento === ""
    ) {
      setMsgErro("Campo data de nascimento obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    }

    if (typeof Cadastro.nome === "undefined" || Cadastro.nome === "") {
      setMsgErro("Campo nome obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    }
    if (
      typeof Cadastro.documento === "undefined" ||
      Cadastro.documento === ""
    ) {
      setMsgErro("Campo CPF/CNPJ obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      return;
    } else if (
      !validateCPF(Cadastro.documento) &&
      !validateCNPJ(Cadastro.documento)
    ) {
      setMsgErro("CPF/CNPJ inválido");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    }
    if (typeof Cadastro.telefone === "undefined" || Cadastro.telefone === "") {
      setMsgErro("Campo celular obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    } else if (!validatePhone(Cadastro.telefone)) {
      setMsgErro("Telefone inválido");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    }
    if (typeof Cadastro.cep === "undefined" || Cadastro.cep === "") {
      setMsgErro("Campo CEP obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    } else if (!validateCep(Cadastro.cep) || isCepInvalido) {
      setMsgErro("CEP inválido");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    }
    if (
      typeof Cadastro.enderecoBairro === "undefined" ||
      Cadastro.enderecoBairro === ""
    ) {
      setMsgErro("Campo bairro obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    }
    if (typeof Cadastro.endereco === "undefined" || Cadastro.endereco === "") {
      setMsgErro("Campo endereço obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    }
    if (
      typeof Cadastro.enderecoNumero === "undefined" ||
      Cadastro.enderecoNumero === ""
    ) {
      setMsgErro("Campo número obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    }
    if (typeof Cadastro.uf === "undefined" || Cadastro.uf === "") {
      setMsgErro("Campo UF obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    } else if (!validateUF(Cadastro.uf)) {
      setMsgErro("UF inválido");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    }
    if (typeof Cadastro.cidade === "undefined" || Cadastro.cidade === "") {
      setMsgErro("Campo cidade obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      setStep(2);
      return;
    }
    if (certificadoCnpj) {
      if (
        typeof Cadastro.representanteCpf === "undefined" ||
        Cadastro.representanteCpf === ""
      ) {
        setMsgErro("Campo CPF Representante obrigatório");
        setTimeout(() => {
          setMsgErro("");
        }, 6000);
        return;
      } else if (!validateCPF(Cadastro.representanteCpf)) {
        setMsgErro("CPF inválido");
        setTimeout(() => {
          setMsgErro("");
        }, 6000);
        setStep(2);
        return;
      }
      if (
        typeof Cadastro.representanteNome === "undefined" ||
        Cadastro.representanteNome === ""
      ) {
        setMsgErro("Campo Nome Representante obrigatório");
        setTimeout(() => {
          setMsgErro("");
        }, 6000);
        return;
      }
      if (
        typeof Cadastro.emailEmpresa === "undefined" ||
        Cadastro.emailEmpresa === ""
      ) {
        setMsgErro("Campo E-mail Empresa obrigatório");
        setTimeout(() => {
          setMsgErro("");
        }, 6000);
        return;
      }
      if (
        typeof Cadastro.representanteTelefone === "undefined" ||
        Cadastro.representanteTelefone === ""
      ) {
        setMsgErro("Campo Telefone Representante obrigatório");
        setTimeout(() => {
          setMsgErro("");
        }, 6000);
        return;
      }
    }

    if (!check) {
      setMsgErro("Aceitar Política de Privacidade é obrigatório.");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      return;
    }
    GeraVenda(ProdutoCompra.id, ProdutoCompra.anos[0].id, Revenda);

    let negocioDto;
    if (certificadoCnpj) {
      // ja foi criado o contato com o negocio
      const empresaCrm = {
        cnpj: Cadastro.documento,
        razaoSocial: Cadastro.nome,
        emailEmpresa: Cadastro.emailEmpresa,
        tipo: "PROSPECT",
        telefoneEmpresa: Cadastro.telefone,
        origem: "Exactus",
      }
      PostEmpresa(Cadastro.email, empresaCrm)

      negocioDto = {
        idEstagioVenda: crmEstagioExpress.CadastroCNPJ, // cadastro CNPJ
        pipeline: "PIPELINE_EXPRESS",
        produto: ObterProdutoExpress(Number(ProdutoCompra.anos[0].sku)),
      };
      PatchNegocio(negocioDto, Cadastro.email.trim());
    } else {
      // aqui ainda não foi criado o contato com o negocio
      const negocioContatoHub = {
        negocioDto: {
          valor: ProdutoCompra.anos[0].valor,
          idEstagioVenda: crmEstagioExpress.LeadColetado, // lead coletado
          pipeline: "PIPELINE_EXPRESS",
          produto: ObterProdutoExpress(Number(ProdutoCompra.anos[0].sku)),
        },
        contatoDto: {
          email: Cadastro.email.trim(),
          nome: Cadastro.nome,
          telefone: Cadastro.telefone,
          dataNascimento: convertToISO(Cadastro.dataNascimento),
          cpf: Cadastro.documento,
          origem: "Exactus",
          gclid: gclid,
        },
      };
      NegocioComContato(negocioContatoHub);
    }


    navigate("/compra");
  };

  const consultarCep = () => {
    const cep = String(Cadastro.cep).replace(/\D/g, "");
    if (cep.length === 8) {
      fetchEndereco(Cadastro.cep).then((response) => {
        setCadastro({
          ...Cadastro,
          endereco: response?.logradouro,
          enderecoBairro: response?.bairro,
          cidade: response?.cidade,
          uf: response?.uf,
        });
      });
    }
  };
  const dataCardSelecionado = {
    icone: verificaIcone(ProdutoCompra?.resumo),
    valor: ProdutoCompra?.anos[0].valor.toFixed(2),
    titulo: ProdutoCompra?.descricaoResumida.split("-")[0],
    modelo: ProdutoCompra?.descricaoResumida.split("-")[0].split(" ")[1],
    formato: ProdutoCompra?.descricaoResumida.split("-")[1],
    validade: ProdutoCompra?.anos[0].descricao,
  };
  const [certificadoCnpj, setCertificadoCnpj] = useState();

  function verificaTipoDoCertificado(certificado) {
    if (certificado.includes("CNPJ")) {
      setCertificadoCnpj(true);
    } else setCertificadoCnpj(false);
  }

  function verificaIcone(item) {
    if (!item || typeof item !== "string") {
      return certificadoescudo;
    }
    if (item.includes("Cartão + Leitora")) {
      return cartaoleitora;
    } else if (item.includes("Cartão")) {
      return cartao;
    } else if (item.includes("Token")) {
      return token;
    } else if (item.includes("Arquivo")) {
      return file;
    } else if (item.includes("Nuvem")) {
      return certificadoescudo;
    } else {
      return certificadoescudo;
    }
  }

  // serve apenas para quando for cnpj
  const primeiroForm = () => {
    const negocioContatoHub = {
      negocioDto: {
        valor: ProdutoCompra.anos[0].valor,
        idEstagioVenda: crmEstagioExpress.LeadColetado, // lead coletado
        pipeline: "PIPELINE_EXPRESS",
        produto: ObterProdutoExpress(Number(ProdutoCompra.anos[0].sku)),
      },
      contatoDto: {
        email: Cadastro.email.trim(),
        nome: Cadastro.representanteNome,
        telefone: Cadastro.representanteTelefone,
        dataNascimento: convertToISO(Cadastro.dataNascimento),
        cpf: Cadastro.representanteCpf,
        origem: "Exactus",
        gclid: gclid,
      },
    };

    NegocioComContato(negocioContatoHub);

    handleNext();
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    setAbreModal(false);
    setCadastro("");

    const params = new URLSearchParams(location.search);
    const gclidParam = params.get("gclid");

    if (gclidParam) {
      setGclid(gclidParam);
    }
  }, []);

  useEffect(() => {
    consultarCep();
  }, [Cadastro.cep]);

  useEffect(() => {
    if (!certificadoCnpj && step > 1) {
      setCadastro({
        ...Cadastro,
        representanteCpf: Cadastro.documento,
        representanteNome: Cadastro.nome,
        representanteTelefone: Cadastro.telefone,
      });
    }
  }, [Cadastro.documento, Cadastro.nome, Cadastro.telefone]);

  const renderContent = (key) => {
    switch (key) {
      case 1:
        return (
          <div className="step-coluna" style={{ color: "#4C4C4C" }}>
            <div className="step-um-box-mensagem">
              <span className="step-um-titulo">
                Este é o melhor modelo para você?
              </span>
              <span className="step-um-subtitulo">{ProdutoCompra?.resumo}</span>
              <button
                onClick={() => navigate("/certificado")}
                className="step-um-botao-aviso"
              >
                Acho que escolhi o certificado errado!
              </button>
            </div>

            <div className="step-um-box-pergunta">
              <span className="step-um-subtitulo">
                Você possui carteira nacional de habilitação CNH?
              </span>
              <div className="step-um-box-opcoes">
                <label className="custom-checkbox">
                  <input
                    type="radio"
                    name="cnh"
                    value="sim"
                    onChange={() => setTemCNH("sim")}
                    checked={temCNH === "sim"}
                  />
                  <span className="checkmark"></span>
                  Sim eu tenho CNH
                </label>
                <label className="custom-checkbox">
                  <input
                    type="radio"
                    name="cnh"
                    value="nao"
                    onChange={() => setTemCNH("nao")}
                    checked={temCNH === "nao"}
                  />
                  <span className="checkmark"></span>
                  Não tenho CNH
                </label>
              </div>

              {temCNH === "nao" && (
                <div className="step-um-box-pergunta">
                  <span className="step-um-subtitulo">
                    Você já emitiu certificado digital anteriormente?
                  </span>
                  <div className="step-um-box-opcoes">
                    <label className="custom-checkbox">
                      <input
                        type="radio"
                        name="certificado"
                        value="sim"
                        onChange={() => setEmitiuCertificado("sim")}
                        checked={emitiuCertificado === "sim"}
                      />
                      <span className="checkmark"></span>
                      Sim
                    </label>
                    <label className="custom-checkbox">
                      <input
                        type="radio"
                        name="certificado"
                        value="nao"
                        onChange={() => setEmitiuCertificado("nao")}
                        checked={emitiuCertificado === "nao"}
                      />
                      <span className="checkmark"></span>
                      Não
                    </label>
                  </div>
                </div>
              )}

              <button
                type="button"
                className="btn-primario"
                disabled={!podeAvancar}
                onClick={() => {
                  handleNext();
                  verificaTipoDoCertificado(dataCardSelecionado.titulo);
                }}
              >
                Próxima etapa
              </button>
              {emitiuCertificado === "nao" && (
                <i style={{ fontSize: "13px" }}>
                  Essa opção de emissão exige CNH ou certificado digital anterior.
                  Com outros documentos, não conseguimos concluir o processo online.
                </i>
              )}
            </div>
          </div>
        );
      case 2:
        return (
          <form
            id="form_certificado_cpf"
            onSubmit={verifica}
            className="step-coluna"
            style={{ color: "#4C4C4C" }}
          >
            <div className="step-um-box-mensagem">
              <span className="step-um-titulo">Identificação: </span>
              {certificadoCnpj ? (
                <>
                  <span className="step-um-subtitulo" style={{ width: "60%" }}>
                    Informe os dados do representente legal da sua empresa.
                  </span>
                  <i style={{ width: "65%", fontSize: "14px" }}>
                    Essa pessoa será responsável pela assinatura do certificado
                    digital da sua empresa.
                  </i>
                </>
              ) : (
                <>
                  <span className="step-um-subtitulo">
                    Preencha com atenção.
                  </span>
                  <i style={{ width: "65%", fontSize: "14px" }}>
                    Esses dados serão usados para gerar seu certificado com
                    validade jurídica
                  </i>
                </>
              )}
              <div className="step-formulario">
                {certificadoCnpj ? (
                  <div className="input">
                    <input
                      placeholder="Nome"
                      type="text"
                      name="representanteNome"
                      id="representanteNome"
                      value={Cadastro.representanteNome}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                ) : (
                  <div className="input">
                    <input
                      placeholder="Nome Completo"
                      type="text"
                      name="nome"
                      id="nome"
                      value={Cadastro.nome}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                )}

                <div className="input">
                  <input
                    placeholder="E-mail"
                    required
                    type="email"
                    name="email"
                    id="email"
                    value={Cadastro.email}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                {certificadoCnpj ? (
                  <div className="input">
                    <InputMask
                      placeholder="Telefone"
                      mask="99 99999-9999"
                      name="representanteTelefone"
                      id="representanteTelefone"
                      value={Cadastro.representanteTelefone}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                ) : (
                  <div className="input">
                    <InputMask
                      placeholder="Telefone"
                      mask="99 99999-9999"
                      name="telefone"
                      id="telefone"
                      value={Cadastro.telefone}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                )}

                {certificadoCnpj ? (
                  <div className="input">
                    <InputMask
                      placeholder="CPF"
                      mask="999.999.999-99"
                      name="representanteCpf"
                      id="representanteCpf"
                      value={Cadastro.representanteCpf}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                ) : (
                  <div className="input">
                    <InputMask
                      placeholder="CPF"
                      mask="999.999.999-99"
                      name="documento"
                      id="documento"
                      value={Cadastro.documento}
                      onChange={(e) => handleChange(e)}
                      checked
                    />
                  </div>
                )}

                <div className="input">
                  <InputMask
                    placeholder="Data de nascimento"
                    mask="99/99/9999"
                    name="dataNascimento"
                    id="dataNascimento"
                    value={Cadastro.dataNascimento}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="input" style={{ width: "45%" }}>
                    <InputMask
                      placeholder="CEP"
                      mask="99999-999"
                      name="cep"
                      id="cep"
                      value={Cadastro.cep}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="input" style={{ width: "52%" }}>
                    <input
                      placeholder="Bairro"
                      type="text"
                      name="enderecoBairro"
                      id="enderecoBairro"
                      value={Cadastro.enderecoBairro}
                      onChange={(e) => handleChange(e)}
                      disabled={disabledFields.bairro}
                    />
                  </div>
                </div>
                <div className="input">
                  <input
                    placeholder="Endereço"
                    type="text"
                    name="endereco"
                    id="endereco"
                    value={Cadastro.endereco}
                    onChange={(e) => handleChange(e)}
                    disabled={disabledFields.logradouro}
                  />
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="input" style={{ width: "30%" }}>
                    <input
                      placeholder="Numero"
                      type="text"
                      name="enderecoNumero"
                      id="enderecoNumero"
                      value={Cadastro.enderecoNumero}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="input" style={{ width: "67%" }}>
                    <input
                      placeholder="Complemento"
                      type="text"
                      name="enderecoComplemento"
                      id="enderecoComplemento"
                      value={Cadastro.enderecoComplemento}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="input" style={{ width: "48%" }}>
                    <InputMask
                      placeholder="UF"
                      mask="aa"
                      name="uf"
                      id="uf"
                      value={Cadastro.uf}
                      onChange={(e) => handleChange(e)}
                      disabled={disabledFields.uf}
                    />
                  </div>
                  <div className="input" style={{ width: "49%" }}>
                    <input
                      placeholder="Cidade"
                      type="text"
                      name="cidade"
                      id="cidade"
                      value={Cadastro.cidade}
                      onChange={(e) => handleChange(e)}
                      disabled={disabledFields.cidade}
                    />
                  </div>
                </div>
                {!certificadoCnpj && (
                  <div
                    className="input-checkbox"
                    style={{ marginBottom: "50px" }}
                  >
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        name="politica"
                        id="politica"
                        checked={check}
                        onChange={(e) => handleCheckbox(e)}
                      />
                      <span className="checkmark"></span>
                      <span>
                        Li e aceito a{" "}
                        <NavLink to="/politica-de-privacidade">
                          Política de Privacidade
                        </NavLink>{" "}
                        da Exactus Software.
                      </span>
                    </label>
                  </div>
                )}
              </div>
              {certificadoCnpj ? (
                <div style={{ display: "flex", gap: "15px" }}>
                  <button
                    type="button"
                    className="btn-primario-outline"
                    onClick={handlePrev}
                  >
                    Voltar
                  </button>

                  <button
                    type="button"
                    className="btn-primario"
                    onClick={primeiroForm}
                  >
                    Próxima etapa 1
                  </button>
                </div>
              ) : (
                <div style={{ display: "flex", gap: "15px" }}>
                  <button
                    type="button"
                    className="btn-primario-outline"
                    onClick={handlePrev}
                  >
                    Voltar
                  </button>

                  <button type="submit" className="btn-primario">
                    Próxima etapa
                  </button>
                </div>
              )}
            </div>
          </form>
        );

      case 3:
        return (
          <form
            id="form_certificado_empresa"
            onSubmit={verifica}
            className="step-coluna"
            style={{ color: "#4C4C4C" }}
          >
            <div className="step-um-box-mensagem">
              <span className="step-um-titulo">Identificação: </span>
              <span className="step-um-subtitulo">Dados da Empresa</span>
              <i style={{ width: "65%", fontSize: "14px" }}>
                Agora precisamos confirmar os dados da empresa que será
                certificada, preencha os dados complementares abaixo.
              </i>
              <div className="step-formulario">
                <div className="input">
                  <input
                    placeholder="Nome"
                    type="text"
                    name="representanteNome"
                    id="representanteNome"
                    value={Cadastro.representanteNome}
                    onChange={(e) => handleChange(e)}
                    style={{ display: "none" }}
                  />
                </div>

                <div className="input">
                  <input
                    placeholder="E-mail"
                    required
                    type="email"
                    name="email"
                    id="email"
                    value={Cadastro.email}
                    onChange={(e) => handleChange(e)}
                    style={{ display: "none" }}
                  />
                </div>

                <div className="input">
                  <InputMask
                    placeholder="Telefone"
                    mask="99 99999-9999"
                    name="representanteTelefone"
                    id="representanteTelefone"
                    value={Cadastro.representanteTelefone}
                    onChange={(e) => handleChange(e)}
                    style={{ display: "none" }}
                  />
                </div>
                <div className="input">
                  <InputMask
                    placeholder="CPF"
                    mask="999.999.999-99"
                    name="representanteCpf"
                    id="representanteCpf"
                    value={Cadastro.representanteCpf}
                    onChange={(e) => handleChange(e)}
                    style={{ display: "none" }}
                  />
                </div>

                <div className="input">
                  <InputMask
                    placeholder="Data de nascimento"
                    mask="99/99/9999"
                    name="dataNascimento"
                    id="dataNascimento"
                    value={Cadastro.dataNascimento}
                    onChange={(e) => handleChange(e)}
                    style={{ display: "none" }}
                  />
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="input" style={{ width: "45%" }}>
                    <InputMask
                      placeholder="CEP"
                      mask="99999-999"
                      name="cep"
                      id="cep"
                      value={Cadastro.cep}
                      onChange={(e) => handleChange(e)}
                      style={{ display: "none" }}
                    />
                  </div>
                  <div className="input" style={{ width: "52%" }}>
                    <input
                      placeholder="Bairro"
                      type="text"
                      name="enderecoBairro"
                      id="enderecoBairro"
                      value={Cadastro.enderecoBairro}
                      onChange={(e) => handleChange(e)}
                      disabled={disabledFields.bairro}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
                <div className="input">
                  <input
                    placeholder="Endereço"
                    type="text"
                    name="endereco"
                    id="endereco"
                    value={Cadastro.endereco}
                    onChange={(e) => handleChange(e)}
                    disabled={disabledFields.logradouro}
                    style={{ display: "none" }}
                  />
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="input" style={{ width: "30%" }}>
                    <input
                      placeholder="Numero"
                      type="text"
                      name="enderecoNumero"
                      id="enderecoNumero"
                      value={Cadastro.enderecoNumero}
                      onChange={(e) => handleChange(e)}
                      style={{ display: "none" }}
                    />
                  </div>
                  <div className="input" style={{ width: "67%" }}>
                    <input
                      placeholder="Complemento"
                      type="text"
                      name="enderecoComplemento"
                      id="enderecoComplemento"
                      value={Cadastro.enderecoComplemento}
                      onChange={(e) => handleChange(e)}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="input" style={{ width: "48%" }}>
                    <InputMask
                      placeholder="UF"
                      mask="aa"
                      name="uf"
                      id="uf"
                      value={Cadastro.uf}
                      onChange={(e) => handleChange(e)}
                      disabled={disabledFields.uf}
                      style={{ display: "none" }}
                    />
                  </div>
                  <div className="input" style={{ width: "49%" }}>
                    <input
                      placeholder="Cidade"
                      type="text"
                      name="cidade"
                      id="cidade"
                      value={Cadastro.cidade}
                      onChange={(e) => handleChange(e)}
                      disabled={disabledFields.cidade}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>

                {/* ESCONDER CAMPOS A CIMA */}
                <div className="input">
                  <InputMask
                    placeholder="CNPJ"
                    mask="99.999.999/9999-99"
                    name="documento"
                    id="documento"
                    value={Cadastro.documento}
                    onChange={(e) => handleChange(e)}
                  />
                </div>

                <div className="input">
                  <input
                    placeholder="Nome Empresa"
                    type="text"
                    name="nome"
                    id="nome"
                    value={Cadastro.nome}
                    onChange={(e) => handleChange(e)}
                  />
                </div>

                <div className="input">
                  <input
                    placeholder="E-mail Empresa"
                    type="email"
                    name="emailEmpresa"
                    id="emailEmpresa"
                    value={Cadastro.emailEmpresa}
                    onChange={(e) => handleChange(e)}
                  />
                </div>

                <div className="input">
                  <InputMask
                    placeholder="Telefone Empresa"
                    mask="99 99999-9999"
                    name="telefone"
                    id="telefone"
                    value={Cadastro.telefone}
                    onChange={(e) => handleChange(e)}
                  />
                </div>

                <div
                  className="input-checkbox"
                  style={{ marginBottom: "50px" }}
                >
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      name="politica"
                      id="politica"
                      checked={check}
                      onChange={(e) => handleCheckbox(e)}
                    />
                    <span className="checkmark"></span>
                    <span>
                      Li e aceito a{" "}
                      <NavLink to="/politica-de-privacidade">
                        Política de Privacidade
                      </NavLink>{" "}
                      da Exactus Software.
                    </span>
                  </label>
                </div>
              </div>
              <div style={{ display: "flex", gap: "15px" }}>
                <button
                  type="button"
                  className="btn-primario-outline"
                  onClick={handlePrev}
                >
                  Voltar
                </button>

                <button type="submit" className="btn-primario">
                  Próxima etapa 2
                </button>
              </div>
            </div>
          </form>
        );
    }
  };

  return (
    <>
      {msgErro && <Erro />}
      <div className="cadastro">
        <div className="step-container">
          <CardCertificadoSelecionado
            image={dataCardSelecionado.icone}
            modelo={dataCardSelecionado.modelo}
            formato={dataCardSelecionado.formato}
            titulo={dataCardSelecionado.titulo}
            validade={dataCardSelecionado.validade}
            valor={dataCardSelecionado.valor}
          />
          {renderContent(step)}
        </div>
      </div>
      <Footer footerCertificado={true} />
    </>
  );
}

export default Cadastro;